module.exports = __webpack_public_path__ + "img/sls2.349e041c.jpg";